// PageShell.js
import React from "react";
import "./PageShell.css";
import "../style.css"
import "./Button.css"
import "./Welcome.css"
import Header from "../Header/Header";
import HeroMillionsPhone from "../Header/HeroMillionsPhone"
import MovingTicker from "../Header/MovingTicker"
import Page from "../Page1Main/Page";
import SaverCreditGrid from "../Page1Main/SaverCreditGrid";
import SaversQuickGate from "../Page1Main/SaversQuickGate";
import SaverCreditCallout from "../Page1Main/SaverCreditCallout";
import Phone from "../Phone/Phone";
import NowVsFutureComparison from "../Phone/NowVsFutureComparison";
import NowVsFutureSection from "../Phone/NowVsFutureSection";

import ProUpdatesSection from "../Comms/ProUpdatesSection";
import Section1 from "../Page1Main/Sections/Section1";
import { Link } from "react-router-dom";
import SaverCreditTwoUp from "./SaverCreditTwoUp";
import MiniSaver from "../Comms/MiniSaver"
import Mini1 from "../Comms/MiniSaver1";

import MFSSaverCreditExample from "../Page1Main/MFSSaverCreditExample";

import { useTranslation } from "react-i18next";
import DependentClassifier from "../Tools/DependentClassifier";
import StoriesAccordion from "../Jordan/StoriesAccordion";
import RothEducationHelper from "../Jordan/RothEducationHelper";
import Form1040Flow from "../TryAgain/Form1040Flow";
import GildarcCustomerLanding from "../TryAgain/GildarcCustomerLanding";
import SaversCreditStory1 from "../Jordan/SaversCreditStory1";
import SaversCreditSteps from "../Jordan/SaversCreditSteps";
import ModulesOverview from "../TryAgain/ModulesOverview";
import SaversAnsweringMachine from "../TryAgain/SaversAnsweringMachine";
import PathsLanding from "../Path/PathsLanding";
const PageShell = () => {
  const { t } = useTranslation();
  return (
    <div>
<div className="ticker-fixed">
  <MovingTicker>
    <>
    {/*}
      Millions of taxfilers miss out on benefits simply because we didn’t have guidance like Gildarc.
      This isn’t the usual tax education - for that you can visit
      <a
        href="https://apps.irs.gov/app/understandingTaxes/teacher/hows.jsp"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#0f62fe", textDecoration: "underline", marginLeft: "6px" }}
      >
        the IRS Understanding Taxes site
      </a>.
      This explains the stages professionals usually charge money to walk people through.
   */}  </>
   {t("msg")} 
  </MovingTicker>
</div>



      <div className="page-wrapper">
        <div className="page-root">
          <div className="page-container">





            <Header>

            </Header>   


       
            <GildarcCustomerLanding />


















      
         

            {/* MAIN CONTENT */}





          </div>
        </div>





































    



    </div>
       <footer className="site-footer">
                    <div className="footer-disclaimer">
                      
                      
                    </div>
                   <Link to="/legal" className="legal-link">
  Terms of Use
</Link>
                </footer>

</div>

  );
};

export default PageShell;
